export default function mobileNav() {
	const navTrigger = document.querySelector('.nav-trigger');
	const body = document.body;
	const mainNav = document.querySelector('.main-navigation');
	const navItemsArr = Array.from(
		document.querySelectorAll('.main-navigation li a')
	);

	if (!navTrigger || !mainNav || !body) return;

	navTrigger.addEventListener('click', (e) => {
		e.preventDefault();
		body.classList.toggle('nav-open');
		mainNav.classList.toggle('menu-open');
		navTrigger.setAttribute(
			'aria-expanded',
			body.classList.contains('nav-open')
		);
	});

	navItemsArr.forEach((navItem) => {
		navItem.addEventListener('click', (e) => {
			const parent = navItem.closest('li');
			const hasSubmenu = parent?.classList.contains('menu-item-has-children');

			if (hasSubmenu) {
				// NE FERME PAS le menu si c’est un lien parent de sous-menu
				return;
			}

			if (body.classList.contains('nav-open')) {
				body.classList.remove('nav-open');
				mainNav.classList.remove('menu-open');
				navTrigger.setAttribute('aria-expanded', 'false');
			}
		});
	});
}
